<template>
    <footer class="footer has-background-white" :class="{'has-background-black-ter': this.$root.$children[0].darkTheme}">
        <div class="content has-text-centered bg">
            <dir style="height: 55%" class="has-text-centered">
            <iframe src="https://player.vimeo.com/video/119261068?color=00ffcc&amp;title=0&amp;byline=0&amp;portrait=0" width="640" height="480" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
            </dir>
            <h2 class="title is-3 has-text-centered mt-5"  :class="{'has-text-white': this.$root.$children[0].darkTheme}">
            And many more (smaller) projects can be found on <a href="https://github.com/radean" target="blank">my GitHub</a>!
            </h2>
            <p :class="{'has-text-white-ter': this.$root.$children[0].darkTheme}">
                © Wajahat Mughal {{ date }}
            </p>
        </div>
    </footer>
</template>

<script>
export default {
  components: {},
  data() {
      return {
          date: new Date().getFullYear()
      }
  }
}
</script>

<style lang="scss" scoped>
.footer {
    position: relative;
    height: 600px;
    background-image: url("https://storage.radean.xyz/img/back/bg.png");
    background-size: cover;
}
.content > a {
    font-size: 1.3em;
}
.content > p {
    position: relative;
    top: 20px;
}
</style>